module.exports = __webpack_public_path__ + "media/icons/default_listing_image-63eb3bc2.svg";